// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.properties.addresses.RentalManagerPropertyAddressVerificationWebApiHandler

import type { QueryOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerPropertyAddressVerificationWebApiHandler_verification,
  RentalManagerPropertyAddressVerificationWebApiHandler_verification_Path,
} from '@zg-rentals/ts-rental-manager-api-client';

import type { RentalManagerPropertyAddressDetailsDto } from '@zg-rentals/ts-rental-manager-api-client';

interface VerificationParams {
  fullAddress: string;
  propertyTypeCode?: number;
  unit?: string;
}

export type RentalManagerPropertyAddressVerificationWebApiHandler_verification_Options = UseQueryOptions<
  RentalManagerPropertyAddressDetailsDto,
  unknown,
  RentalManagerPropertyAddressDetailsDto,
  readonly [string, VerificationParams]
>;

const RentalManagerPropertyAddressVerificationWebApiHandler_verification_GetKey = (getParams: VerificationParams) =>
  [RentalManagerPropertyAddressVerificationWebApiHandler_verification_Path, getParams] as const;

export const RentalManagerPropertyAddressVerificationWebApiHandler_verification_queryOptions = (
  getParams: VerificationParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerPropertyAddressVerificationWebApiHandler_verification_GetKey(getParams),
    queryFn: () => RentalManagerPropertyAddressVerificationWebApiHandler_verification(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Validate an address
 */
export const useRentalManagerPropertyAddressVerificationWebApiHandler_verification = (
  getParams: VerificationParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerPropertyAddressVerificationWebApiHandler_verification_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerPropertyAddressVerificationWebApiHandler_verification_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerPropertyAddressVerificationWebApiHandler_verification.getKey =
  RentalManagerPropertyAddressVerificationWebApiHandler_verification_GetKey;
